import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { useLanguage } from "../../../contexts/LanguageContext";

const StockLogDialog = ({
  visible,
  onHide,
  partCode,
  rows = [],
  loading = false,
  totalCount = 0,
  pagination = { PageNumber: 1, PageSize: 10 },
  onPageChange = () => { }
}) => {
  const { th } = useLanguage();

  const transactionTemplate = (row) => {
    const t = Number(row.transactionType ?? 0);
    const isIn = t === 1 || t === 10;
    return (
      <Tag
        value={isIn ? (th("dealerStockReport.incoming") || "Giriş") : (th("dealerStockReport.outgoing") || "Çıkış")}
        severity={isIn ? "success" : "danger"}
      />
    );
  };

  const qtyTemplate = (row) => (
    <span style={{ fontWeight: 600 }}>{row.quantity}</span>
  );

  const dateTemplate = (row) => {
    try {
      const d = new Date(row.createdDate);
      if (isNaN(d.getTime())) return "-";
      return d.toLocaleString();
    } catch {
      return "-";
    }
  };

  return (
    <Dialog
      header={`${th("dealerStockReport.historyTitle") || "Kayıt Geçmişi"} - ${partCode || ""}`}
      visible={visible}
      style={{ width: "90vw", maxWidth: 1200 }}
      modal
      onHide={onHide}
    >
      <DataTable
        value={rows}
        dataKey="id"
        paginator
        first={(pagination?.PageNumber - 1) * (pagination?.PageSize || 10)}
        rows={pagination?.PageSize || 10}
        totalRecords={totalCount}
        onPage={onPageChange}
        loading={loading}
        showGridlines
        stripedRows
        emptyMessage={th("dealerStockReport.emptyLogs") || "Kayıt bulunamadı"}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        tableStyle={{ minWidth: "70rem" }}
      >
        <Column field="createdDate" header={th("dealerStockReport.opDate") || "İşlem Tarihi"} body={dateTemplate} sortable />
        <Column field="createdName" header={th("dealerStockReport.user") || "Kullanıcı"} sortable />
        <Column field="transactionType" header={th("dealerStockReport.op") || "İşlem"} body={transactionTemplate} sortable />
        <Column field="description" header={th("dealerStockReport.description") || "Açıklama"} sortable />
        <Column field="orderNumber" header={th("dealerStockReport.orderNo") || "Sipariş No"} sortable />
        <Column field="invoiceSerialNum" header={th("dealerStockReport.invoiceNo") || "Fatura No"} sortable />
        <Column field="warrClaimsNo" header={th("dealerStockReport.claimNo") || "Garanti Talep No"} sortable />
        <Column field="quantity" header={th("dealerStockReport.qty") || "Miktar"} body={qtyTemplate} sortable />
        <Column field="uom" header={th("dealerStockReport.uom") || "Birim"} sortable />
      </DataTable>
    </Dialog>
  );
};

export default StockLogDialog;
